import {createContext} from "react";

export interface SearchErrorMessageContextType {
    searchErrorMessage: string | null
    setSearchErrorMessage?: (message: string | null) => void
}
export const SearchErrorMessageContext = createContext<SearchErrorMessageContextType>({searchErrorMessage: null});